export default {
  decorateGlobal: {
    globalConfig: 'Mini Program Global Settings',
    pageConfig: 'Page Navigation',
    themeConfig: 'Theme Settings',
    splashScreenConfig: 'Splash Screen',
    dialogConfig: 'Popup Settings',
    shareConfig: 'Share Settings',
    tabBarConfig: 'Home Tab Bar',
    floatButtonConfig: 'Floating Button',
    pageNavigationConfig: 'Page Navigation',
    pageTitle: 'Page Title',
    navigationTitle: 'Navigation Title',
    titleDisplay: 'Title Display',
    titleColor: 'Title Color',
    navigationBar: 'Navigation Bar',
    navigationBarDisplay: 'Show Navigation Bar',
    display: 'Show',
    hide: 'Hide',
    transparentNavigation: 'Transparent Navigation',
    navigationBackgroundColor: 'Scrolled Navigation Background',
    navigationTextColor: 'Scrolled Navigation Text',
    navigationFixedTop: 'Fix Navigation to Top',
    backButton: 'Back Button',
    navigationImage: 'Navigation Image',
    scrolledNavigationImage: 'Scrolled Image',
    navigationImageHint: 'Recommended: 110px × 40px or the same aspect ratio',
    imageWidth: 'Image Width',
    imageHeight: 'Image Height',
    imageCentered: 'Center Image',
    storeModeCenterHint: 'Centering is recommended in store mode.',
    leftDistance: 'Left Offset',
    pageBackground: 'Page Background',
    pageBackgroundHeight: 'Background Height',
    themeColor: 'Theme Color',
    themeTextColor: 'Theme Text Color',
    themeColorHint: 'Icon colors, button backgrounds and selection controls',
    themeTextColorHint: 'Button text color',
    backgroundColorHint: 'Navigation and module background color',
    backgroundTextColor: 'Background Text Color',
    backgroundTextColorHint: 'Text on navigation and module backgrounds (avoid using the same text and background color)',
    statusBarColor: 'Status Bar Color',
    black: 'Black',
    white: 'White',
    otherSettings: 'Other Settings',
    multilingualSwitch: 'Language Switcher',
    isEnabled: 'Enabled',
    enabled: 'On',
    disabled: 'Off',
    image: 'Image',
    splashPage: 'Splash Screen',
    splashImageHint: '750px × 1623px or the same aspect ratio',
    dialogImageHint: '400px × 450px or the same aspect ratio',
    recommendedSize: 'Recommended Size',
    jumpLink: 'Destination',
    clickToView: 'Allow Click',
    displaySeconds: 'Display Seconds',
    intervalHours: 'Interval Hours',
    hourUnit: 'hours',
    secondUnit: 'seconds',
    pixelUnit: 'px',
    closePanel: 'Close',
    viewCode: 'Code',
    resetConfig: 'Reset',
    configHelp: 'Configuration Help',
    shareIconDisplay: 'Show Share Icon',
    shareImage: 'Share Image',
    shareTitle: 'Share Title',
    shareDescription: 'Share Description',
    shareIcon: 'Share Icon',
    shareIconHint: 'Recommended: 26px × 26px or the same aspect ratio',
    defaultShareTitle: 'Share My Favorites',
    defaultShareDescription: 'Great finds are waiting. Join now!',
    message: 'Messages',
    shoppingCart: 'Cart',
    buttonSize: 'Button Size',
    rightDistance: 'Right Offset',
    bottomDistance: 'Bottom Offset',
    openIcon: 'Open Icon',
    closeIcon: 'Close Icon',
    tabBarSettings: 'Home Tab Bar Settings',
    customIcon: 'Custom Icons',
    no: 'No',
    yes: 'Yes',
    defaultIcon: 'Default Icon Set',
    iconNumber: 'Icon {number}',
    tabIconHint: '80px × 80px or the same aspect ratio',
    icon: 'Icon',
    unselected: 'Unselected',
    selected: 'Selected',
    defaultColor: 'Default Color',
    selectedColor: 'Selected Color',
    unselectedIcon: 'Unselected Icon',
    selectedIcon: 'Selected Icon',
    addTabBarItem: 'Add Tab Item',
  },
};
